import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllTaskStatusQuery($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllTaskStatus (pagination: $pagination, sorts: $sorts, where: $where){
            count,
            items{id, name, color, createdAt, updatedAt}
      }
    }
  `

  export default query;